@let chartId = store.chartIdSg();
@let isMutating =
  chartId &&
  store.treeEditorFeature.selectors
    .isMutating({
      chartId,
    })
    .asSignal();

<div
  footer
  class="atn-summit-org-chart-node-panel-footer"
>
  <atn-ds-button
    type="transparent"
    (click)="
      chartId &&
        store.treeEditorFeature.actions.cancelEdits
          .from('OrgChart.EditNodeModal.Footer.CancelButton.Clicked')
          .dispatch({ chartId })
    "
  >
    Cancel
  </atn-ds-button>

  <atn-ds-button
    [loading]="isMutating"
    (click)="
      chartId &&
        !isMutating &&
        store.treeEditorFeature.actions.saveEdits
          .from('OrgChart.EditNodeModal.Footer.SaveButton.Clicked')
          .dispatch({ chartId })
    "
  >
    Save
  </atn-ds-button>
</div>
